import { render, staticRenderFns } from "./MaterialBindingRecord.vue?vue&type=template&id=261cb1b5&scoped=true"
import script from "./MaterialBindingRecord.vue?vue&type=script&lang=js"
export * from "./MaterialBindingRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261cb1b5",
  null
  
)

export default component.exports